import React from 'react'
import {ColorModeSwitcher} from "../../ColorModeSwitcher";
import "./header.css";
import { Box, Link, Stack, Text } from '@chakra-ui/react';
const Header = () => {
  return (
    <div>
        
        <Box display={"flex"} paddingTop={["6","10"]} justifyContent={'space-between'}>
            <Link href='/'><Text children="avibhawnani." fontSize={"4xl"} color={"#8B8D93"} textAlign={["center","left"]}  top={["6","10"]}  paddingStart={["5","9"]}  cursor={"pointer"} fontWeight={"bold"} _hover={{color:"black"}} /> </Link>
            <Box justifyContent={'flex-end'}   marginRight={["4","10"]} marginTop={2}>
              <ColorModeSwitcher/>
            </Box>
        </Box>
        <Stack direction={["column","row-reverse"]} textAlign={"right"} alignItems={"flex-end"}  fontSize={"2xl"}>
            <Link href='/projects' fontWeight={"bold"}  marginRight={["4","10"]} _hover={{color: "#362FD9" , textDecoration:"underline"}}>Side Projects</Link>
            <Link href="/blogs" fontWeight={"bold"} marginRight={["4","10"]} _hover={{color: "#362FD9" , textDecoration:"underline"}}>Blogs</Link>
            <Link href="/about" fontWeight={"bold"} marginRight={["4","10"]} _hover={{color: "#362FD9" , textDecoration:"underline"}}>About Me</Link>
        </Stack>
    </div>
  )
}

export default Header